// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ErrorViewCmp from "../ErrorViewCmp.bs.js";

function PreviouslySentMessagesErrorView(Props) {
  return React.createElement(ErrorViewCmp.make, {
              message: "Loading Failed! Error : API link broken. Please Try reloading the page again"
            });
}

var make = PreviouslySentMessagesErrorView;

export {
  make ,
  
}
/* react Not a pure module */
